/**
 * Saved places and named lists without an account (pure). Saved places live
 * in the visitor's browser (`localStorage`); a named list is shared as a
 * link that carries its name and the places' web names, so the list is the
 * address and needs nothing stored. Accounts can take this over later
 * without changing the link shape.
 */

export const SAVED_PLACES_KEY = "localized:saved";
export const SAVED_PLACES_EVENT = "localized:saved-changed";
export const SAVED_PLACES_LIMIT = 200;

const SLUG = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/** Only well-formed, distinct venue slugs, in order, capped. */
export function cleanSlugs(values: unknown): string[] {
  if (!Array.isArray(values)) return [];
  const out: string[] = [];
  for (const v of values) {
    if (typeof v === "string" && SLUG.test(v) && !out.includes(v)) out.push(v);
    if (out.length >= SAVED_PLACES_LIMIT) break;
  }
  return out;
}

export type SharedList = { name: string; slugs: string[] };

/** The query string for a shareable list: `?name=Cairo+weekend&places=khufus,abou-el-sid`. */
export function sharedListQuery(list: SharedList): string {
  const params = new URLSearchParams();
  const name = list.name.trim().slice(0, 80);
  if (name) params.set("name", name);
  params.set("places", cleanSlugs(list.slugs).join(","));
  return params.toString();
}

/** A shared list from its address; null when it names no places. */
export function parseSharedList(params: { name?: string | string[]; places?: string | string[] }): SharedList | null {
  const places = typeof params.places === "string" ? params.places : "";
  const slugs = cleanSlugs(places.split(","));
  if (slugs.length === 0) return null;
  const name = typeof params.name === "string" ? params.name.trim().slice(0, 80) : "";
  return { name, slugs };
}
